import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncateDecimal',
  standalone: false,
})
export class TruncateDecimalPipe implements PipeTransform {
  transform(value: number): number {
    return Math.trunc(value);
  }
}
